import {
    PermissionRequestParams,
    UpdateWorkerPermissionRequestParams,
} from 'types/settings/permissions';

import { CRMAPIBase } from '@api/crmApiBase';
import {
    PermissionCategoryListResponse,
    PermissionListResponse,
} from '@api/responseModels/permissions/permissionsResponse';

import { RequestResult } from '../responseModels/requestResult';

class PermissionGroup extends CRMAPIBase {
    async getPermissionList(
        params: PermissionRequestParams
    ): Promise<RequestResult<PermissionListResponse>> {
        const result = await this.get<PermissionListResponse>('/permissions', { ...params });
        return result;
    }

    async getCategorizedPermissionList(
        crmId,
        worker_position_id = undefined
    ): Promise<RequestResult<PermissionCategoryListResponse>> {
        const result = await this.get<PermissionCategoryListResponse>('/permissions/categorized', {
            crm_id: crmId,
            worker_position_id,
        });
        return result;
    }

    async getJobStatus(
        crmId: number,
        entity:
            | 'products'
            | 'services'
            | 'tasks'
            | 'customer_profiles'
            | 'worker_positions'
            | 'combo'
            | 'resources',
        worker_position_id: number
    ): Promise<RequestResult<any>> {
        const result = await this.get<any>('/permissions/jobStatus', {
            crm_id: crmId,
            entity,
            worker_position_id,
        });
        return result;
    }

    async updateWorkerPermissions(
        params: UpdateWorkerPermissionRequestParams
    ): Promise<RequestResult<PermissionCategoryListResponse>> {
        const result = await this.post<PermissionCategoryListResponse>(
            '/permissions/change',
            params
        );
        return result;
    }
}

export { PermissionGroup };
